import { isToday, isYesterday, format } from 'date-fns'
import Immutable from 'immutable'

export function getHumanReadableDate(date) {
  if (isToday(new Date(date))) {
    return 'Today'
  }
  if (isYesterday(new Date(date))) {
    return 'Yesterday'
  }
  return format(new Date(date), 'dddd, Do MMMM')
}

export function stripRepetitiveActivities(noteActivities) {
  const canDisplay = (previousNoteActivity, noteActivity) => {
    if (noteActivity.get('type') === 'newComment') {
      return false
    }
    if (
      !previousNoteActivity ||
      previousNoteActivity.get('type') !== noteActivity.get('type')
    ) {
      return true
    }
    return !Immutable.is(
      previousNoteActivity.get('userIds'),
      noteActivity.get('userIds')
    )
  }

  return noteActivities.reduce((memo, noteActivity) => {
    return canDisplay(memo.slice(-1)[0], noteActivity)
      ? memo.concat(noteActivity)
      : memo
  }, [])
}

export function isCommentActivity(noteActivity) {
  return ['newThread', 'newComment'].includes(noteActivity.get('type'))
}
